import { BetTypeEnum } from "src/constants/enums/betType";
import { authorizeSwarmCommand, createBetshopCommand } from "..";
import {
	ISwarmBetMaxStakeCashierRequest,
	ISwarmBetMaxStakeTerminalRequest,
	ISwarmBetshopCommand,
	ISwarmCreateBetCashierRequest,
	ISwarmDoBetTerminalRequest,
	ISwarmDoBookBetTerminalRequest,
	ISwarmGetFreeBetsRequest,
} from "../models/request";

export const getBetMaxStakeTerminalSwarmQuery = (
	eventIds: number[],
	typeId: BetTypeEnum,
	systemMinCount?: number
): [ISwarmBetMaxStakeTerminalRequest, string] => {
	const request: ISwarmBetMaxStakeTerminalRequest = {
		selection_list: eventIds.map(id => ({ SelectionId: id })),
		type_id: typeId,
	}

	if (typeId === BetTypeEnum.System) {
		request.system_min_count = systemMinCount;
	}

	return [authorizeSwarmCommand(request), "terminal_get_bet_max_stake"];
};

export const getBetMaxStakeCashierSwarmQuery = (
	eventIds: number[],
	typeId: BetTypeEnum,
	systemMinCount?: number
): [ISwarmBetshopCommand<ISwarmBetMaxStakeCashierRequest>, string] => {
	const request: ISwarmBetMaxStakeCashierRequest = {
		SelectionList: eventIds.map(id => ({ SelectionId: id })),
		TypeId: typeId,
	};

	if (typeId === BetTypeEnum.System) {
		request.SystemMinCount = systemMinCount;
	}

	return [createBetshopCommand(request, "GetBetMaxStake"), "betshop_command"];
};

export const getHotKeysSwarmQuery = (): [ISwarmBetshopCommand<{}>, string] => [createBetshopCommand({}, "GetSelectionTypeShortCodes"), "betshop_command"];

export const doBetTerminalSwarmQuery = (request: ISwarmDoBetTerminalRequest): [ISwarmDoBetTerminalRequest, string] => [
	authorizeSwarmCommand(request),
	"do_bet_terminal",
];

export const doBookBetTerminalSwarmQuery = (
	request: ISwarmDoBookBetTerminalRequest
): [ISwarmDoBookBetTerminalRequest, string] => [request, "create_bet_book_v2"];

export const checkBetTicketSwarmQuery = (barcode: number) => {
	const request = {
		bar_code: barcode,
		is_with_cashout: true,
	}
	return authorizeSwarmCommand(request);
}

export const getFreeBetsTerminalSwarmQuery = (
	request: ISwarmGetFreeBetsRequest
): [ISwarmGetFreeBetsRequest, string] => [request, "get_freebets_for_betslip"];

export const createBetCashierSwarmQuery = (
	request: ISwarmCreateBetCashierRequest
): [ISwarmBetshopCommand<ISwarmCreateBetCashierRequest>, string] => [
	createBetshopCommand(request, "CreateBet"),
	"betshop_command",
];
